import * as React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimeField, TimeFieldProps } from '@mui/x-date-pickers/TimeField';
import { ClockIcon, DesktopTimePickerProps } from '@mui/x-date-pickers';
import { TextField, TextFieldExtendedProps } from '@components/textField';
import { InputAdornment } from '@mui/material';

interface ITimePicker extends TimeFieldProps<Date> {
  textFieldProps: TextFieldExtendedProps;
}
export const TimePicker = ({
  textFieldProps = {
    autoComplete: 'off',
    placeholder: 'time',
  },

  ...other
}: DesktopTimePickerProps<Date> & ITimePicker) => {
  const handleFieldClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const inputElement = event.currentTarget.querySelector('input') as HTMLInputElement;
    inputElement?.focus();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimeField
        onClick={handleFieldClick}
        {...other}
        slots={{ textField: TextField }}
        slotProps={{
          textField: {
            error: textFieldProps.error,
            helperText: textFieldProps.helperText,
            InputProps: {
              placeholder: textFieldProps.placeholder,
              startAdornment: (
                <InputAdornment position='start' sx={{ height: 0 }}>
                  <ClockIcon style={{ marginRight: '8px', cursor: 'pointer' }} />
                </InputAdornment>
              ),
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};
